import * as React from 'react';
import { Filters as FiltersComponent } from '../../components/Filters';

export function Filters() {
  return <FiltersComponent />;
}
